import CheckBox from '../../../../components/Forms/CheckBox';
import TextInput from '../../../../components/Forms/TextInput';
import styles from './userForm.module.scss';
interface IUserFormProps {
  formik: any;
  isNew?: boolean;
}

function UserForm({ formik, isNew }: IUserFormProps) {
  const { values, touched, errors } = formik;

  const handleChange = (e: any, checkbox?: boolean) => {
    formik.setFieldValue('userUpdated', true);
    if (checkbox) {
      formik.setFieldValue('enableNewsLetter', !e.target.checked);
    } else {
      formik.handleChange(e);
    }
  };

  return (
    <div className={[styles.userForm, isNew ? styles.modal : ''].join(' ')}>
      <h2>Profil Général</h2>
      <TextInput
        label={isNew ? 'Nom du collaborateur' : 'Nom'}
        name="lastName"
        value={values.lastName}
        required={isNew}
        handleChange={(e) => handleChange(e)}
        error={touched.lastName && Boolean(errors.lastName)}
        helperText={touched.lastName && errors.lastName}
      />
      <TextInput
        label={isNew ? 'Prénom du collaborateur' : 'Prénom'}
        name="firstName"
        value={values.firstName}
        required={isNew}
        handleChange={(e) => handleChange(e)}
        error={touched.firstName && Boolean(errors.firstName)}
        helperText={touched.firstName && errors.firstName}
      />
      <TextInput
        type="email"
        label="Email"
        name="email"
        value={values.email}
        required={isNew}
        handleChange={(e) => handleChange(e)}
        error={touched.email && Boolean(errors.email)}
        helperText={touched.email && errors.email}
      />
      <TextInput
        label="Téléphone"
        name="phoneNumber"
        value={values.phoneNumber}
        handleChange={(e) => handleChange(e)}
        error={touched.phoneNumber && Boolean(errors.phoneNumber)}
        helperText={touched.phoneNumber && errors.phoneNumber}
      />
      {!isNew && (
        <CheckBox
          checked={!values.enableNewsLetter}
          name="enableNewsLetter"
          label="Je ne désire pas recevoir la newsletter."
          handleChange={(e) => handleChange(e, true)}
        />
      )}
    </div>
  );
}

export default UserForm;
